import { render, staticRenderFns } from "./ContractVisits.vue?vue&type=template&id=725dfdd1&"
import script from "./ContractVisits.vue?vue&type=script&lang=js&"
export * from "./ContractVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports